(() => {
	const t = {
			pipe: " | ",
			emdash: " — ",
			endash: " – ",
			dash: " - ",
			dot: " . ",
			middot: " · ",
			slash: " / ",
			colon: " : ",
			arrow: " → ",
			bullet: " • ",
			hyphen: " - "
		},
		e = t => {
			if (0 === t || "number" == typeof t) return Math.round(t);
			if (!t) return 0;
			const e = String(t).replace(/\u00A0/g, "").replace(/\s/g, "").replace(/[€£$]|CHF/gi, "").replace(/[^\d,.-]/g, ""),
				r = /,\d{1,2}$/.test(e) ? e.replace(/\.(?=\d{3}\b)/g, "").replace(",", ".") : e.replace(/,(?=\d{3}\b)/g, ""),
				a = parseFloat(r);
			return isNaN(a) ? 0 : Math.round(100 * a)
		},
		r = () => window.Shopify?.currency?.active || document.documentElement.getAttribute("data-shop-currency") || "EUR",
		a = t => {
			try {
				const e = t % 100 == 0 ? {
					style: "currency",
					currency: r(),
					minimumFractionDigits: 0,
					maximumFractionDigits: 0
				} : {
					style: "currency",
					currency: r()
				};
				return new Intl.NumberFormat(document.documentElement.lang || navigator.language || "fr-FR", e).format(t / 100)
			} catch {}
			if (window.Shopify?.formatMoney) {
				const e = window.theme?.moneyFormat || window.Shopify?.money_format || "{{amount}}",
					r = e.replace("{{amount_with_comma_separator}}", "{{amount_no_decimals}}").replace("{{amount_with_space_separator}}", "{{amount_no_decimals}}").replace("{{amount}}", "{{amount_no_decimals}}"),
					a = t % 100 == 0 ? r : e;
				try {
					return Shopify.formatMoney(t, a)
				} catch {}
			}
			return String(t / 100)
		},
		c = t => /[€£$]|(?:USD|EUR|GBP|CAD|AUD|CHF)\b/i.test(t || ""),
		n = t => {
			const e = (t || "").match(/^(.*?)([\d.,\s\u00A0\u202F]+)(.*)$/);
			return {
				pre: e ? e[1] : "",
				post: e ? e[3] : ""
			}
		},
		o = (t, e) => t && t.querySelector ? t.querySelector(e) : null,
		i = (t, e) => t && t.querySelectorAll ? t.querySelectorAll(e) : [],
		u = t => t.closest("product-form, form") || document;

	function p(t) {
		const e = u(t);
		return e?.closest?.('[id^="ProductInfo-"], product-info, .product__info-container, .product') || e || document
	}
	const d = t => String(t || "").replace(/\u00A0|\u202F/g, " ").replace(/\s*\/\s*/g, " / ").replace(/\s+/g, " ").trim().toLowerCase();

	function s(t) {
		if (t.__variantPrettyMap && t.__variantCentsMap) return;
		let r = t.dataset.variantPrices || "";
		if (!r) {
			const e = u(t),
				a = e?.querySelector?.('script[type="application/json"][data-variant-prices]');
			a && (r = a.textContent || a.innerHTML || "")
		}
		let a = [];
		try {
			a = JSON.parse(r || "[]")
		} catch {
			try {
				r = (r || "").replace(/&quot;/g, '"').replace(/&#34;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, "&").replace(/&nbsp;/g, " ").trim(), a = JSON.parse(r || "[]")
			} catch {}
		}
		t.__variantPrettyMap = new Map(a.map((t => [String(t.id), String(t.price_pretty || "")]))), t.__variantCentsMap = new Map(a.map((t => [String(t.id), e(t.price_pretty || 0)])))
	}

	function l(t, r) {
		const a = t.querySelectorAll(".pack__select--container");
		if (!a.length) return 0;
		const c = function(t) {
			const r = p(t);
			if (r.__packVarMap) return r.__packVarMap;
			const a = r.querySelector("#pack-hyperflow-variants") || document.getElementById("pack-hyperflow-variants"),
				c = new Map;
			return a && a.content && a.content.querySelectorAll("option").forEach((t => {
				const r = t.dataset.option || t.textContent || "",
					a = /^\d+$/.test(t.dataset.price || "") ? Number(t.dataset.price) : e(t.dataset.price);
				r && a >= 0 && c.set(d(r), a)
			})), r.__packVarMap = c, c
		}(r);
		if (!c || !c.size) return 0;
		let n = 0;
		a.forEach((t => {
			const e = [];
			if (t.querySelectorAll(".pack__select--item").forEach((t => {
					let r = t.querySelector('.pack-dd__option[aria-selected="true"]')?.getAttribute("value") || t.querySelector("select.pack__select")?.value || "";
					r = String(r || "").trim(), r && e.push(r)
				})), !e.length) return;
			const r = d(e.join(" / ")),
				a = c.get(r);
			"number" == typeof a && a >= 0 && (n += a)
		}));
		const o = Number(t.getAttribute("data-discount-percent") || 0) || 0;
		return n > 0 && o > 0 && (n = Math.round(n * (100 - o) / 100)), n
	}

	function _(t) {
		const r = function(t) {
			const r = p(t),
				a = r.querySelector("component-pack.pack__selected") || r.querySelector("component-pack") || r.querySelector("pack-hyperflow, [data-pack-root], .pack__wrapper, .pack-wrapper");
			if (!a) return 0;
			const c = a.matches("component-pack") ? l(a, t) : 0;
			if (c > 0) return c;
			const n = a.getAttribute?.("data-regular-cents") || a.getAttribute?.("data-price-cents");
			if (n && /^\d+$/.test(n)) return Number(n);
			const o = a.getAttribute?.("data-regular-price") || a.getAttribute?.("data-current-price") || a.getAttribute?.("data-price");
			if (o) {
				const t = e(o);
				if (t > 0) return t
			}
			const i = a.querySelector?.(".pack__price--current, .pack__price, [data-price], .price-item--sale, .price-item--regular");
			if (i) {
				const t = e(i.getAttribute?.("data-price") || i.textContent);
				if (t > 0) return t
			}
			return 0
		}(t) || function(t) {
			const r = u(t),
				a = r?.querySelector?.('[name="id"]')?.value || null;
			if (!a) return 0;
			s(t);
			const c = t.__variantCentsMap.get(String(a));
			if ("number" == typeof c && c > 0) return c;
			const n = r?.variantData?.find?.((t => String(t.id) === String(a)));
			if (n?.price) return Number(n.price) || 0;
			const o = t.dataset.basePrice || t.getAttribute("data-base-price");
			return null != o && "" !== o ? /^\d+$/.test(o) ? Number(o) : e(o) : 0
		}(t);
		return r + function(t) {
			const r = u(t),
				a = r?.getAttribute?.("id"),
				c = r || document,
				n = new Set;
			i(c, ".product-upsell__radio-input:checked, .product-upsell__checkbox-input:checked").forEach((t => n.add(t))), a && i(document, `[data-product-form-id="${a}"] .product-upsell__radio-input:checked, [data-product-form-id="${a}"] .product-upsell__checkbox-input:checked`).forEach((t => n.add(t)));
			let p = 0;
			return n.forEach((t => {
				const r = t.closest(".product-upsell__option, .product-upsell, label.product-upsell__radio, .product-upsell__content") || c;
				let a = 0;
				const n = o(r, ".product-upsell__selector--native");
				if (n && n.options && n.selectedIndex >= 0) {
					const t = n.options[n.selectedIndex],
						r = t?.getAttribute("data-price");
					r && (a = /^\d+$/.test(r) ? Number(r) : e(r))
				}
				if (!a) {
					const t = o(r, '.upsell-dd__option[aria-selected="true"]:not(.is-disabled)') || o(r, ".upsell-dd__option.is-active:not(.is-disabled)"),
						c = t?.getAttribute("data-price") || t?.dataset?.price;
					c && (a = /^\d+$/.test(c) ? Number(c) : e(c))
				}
				if (!a) {
					const r = t.dataset.upsellRawPrice || t.getAttribute("data-upsell-raw-price") || "0",
						c = Number(r);
					a = isNaN(c) ? e(r) : c
				}
				a > 0 && (p += a)
			})), p
		}(t)
	}

	function m(e, r) {
		const o = "true" === e.dataset.priceOnButton || "true" === e.dataset.showPrice,
			i = t[e.dataset.separator || e.dataset.priceSeparator || "dash"] || t.dash;
		let d = e.querySelector(".add-to-cart-separator");
		d || (d = document.createElement("span"), d.className = "add-to-cart-separator", e.appendChild(d));
		let l = e.querySelector(".add-to-cart-price");
		l || (l = document.createElement("span"), l.className = "add-to-cart-price", e.appendChild(l));
		const _ = l.querySelector('[data-role="button-dynamic-price"]') || l;
		if (!o || r <= 0) return d.style.display = "none", void(l.style.display = "none");
		let m = a(r);
		const f = function(t) {
				s(t);
				const e = u(t),
					r = e?.querySelector?.('[name="id"]')?.value || null,
					a = r && t.__variantPrettyMap.get(String(r)) || t.dataset.basePricePretty || t.getAttribute("data-base-price-pretty") || "";
				if (a && c(a)) return a;
				const n = p(t).querySelector(".pack__price--current, .pack__price, [data-price], .price-item--sale, .price-item--regular"),
					o = (n?.textContent || "").trim();
				return c(o) ? o : a || ""
			}(e),
			{
				pre: b,
				post: y
			} = n(f),
			g = m.match(/^(.*?)([\d.,\s\u00A0\u202F]+)(.*)$/);
		g && (b || y) ? m = b + g[2] + y : c(m) || !b && !y || (m = b + m + y), d.textContent = i, _.textContent = m, d.style.display = "", l.style.display = ""
	}

	function f(t) {
		t._priceRaf && cancelAnimationFrame(t._priceRaf), t._priceRaf = requestAnimationFrame((() => {
			const e = _(t);
			t._lastTotal = e, m(t, e), t._priceRaf = null
		}))
	}

	function b(t) {
		if ("1" === t.dataset.priceInit) return;
		t.dataset.priceInit = "1", s(t), f(t), t._mos ||= [];
		const e = e => {
				if (!e) return;
				const r = new MutationObserver((() => f(t)));
				r.observe(e, {
					subtree: !0,
					childList: !0,
					characterData: !0,
					attributes: !0,
					attributeFilter: ["value", "data-price", "data-regular-price", "data-regular-cents", "data-compare-price", "data-variant-id", "aria-hidden", "class", "aria-selected", "aria-expanded"]
				}), t._mos.push(r)
			},
			r = u(t),
			a = p(t);
		e(r?.querySelector('[name="id"]')), e(a.querySelector("pack-hyperflow, component-pack, [data-pack-root], .pack-wrapper, .pack__wrapper")), t._priceWatcher || (t._lastTotal = -1, t._priceWatcher = setInterval((() => {
			if (!document.body.contains(t)) return function(t) {
				t._priceWatcher && (clearInterval(t._priceWatcher), t._priceWatcher = null), t._mos && (t._mos.forEach((t => t.disconnect())), t._mos = [])
			}(t);
			const e = _(t);
			e !== t._lastTotal && (t._lastTotal = e, m(t, e))
		}), 250));
		const c = () => f(t);
		r.addEventListener("change", (t => {
			const e = t.target;
			e && e.matches?.('.product-upsell__radio-input, .product-upsell__checkbox-input, .product-upsell__selector--native, select, [name="id"]') && c()
		}), !0), r.addEventListener("input", (t => {
			const e = t.target;
			e && e.matches?.(".product-upsell__radio-input, .product-upsell__checkbox-input, select") && c()
		}), !0), r.addEventListener("click", (t => {
			const e = t.target;
			e?.closest?.(".upsell-dd__option, .pack-dd__option, .pack__selection, .pack-card, [data-pack-option], .pack-option, .pack, component-pack") && setTimeout(c, 0)
		}), !0), a.addEventListener("change", (t => {
			const e = t.target;
			e?.matches?.(".pack__select--native, .pack__select select") && c()
		}), !0), a.addEventListener("click", (t => {
			t.target?.closest?.(".pack-dd__option, .pack__selection, .pack-card, [data-pack-option]") && setTimeout(c, 0)
		}), !0), r.addEventListener("variant:change", c), r.addEventListener("variantChange", c), document.addEventListener("variant:changed", c)
	}

	function y(t = document) {
		(t.querySelectorAll?.('button.product-form__submit[data-price-on-button="true"], button.product-form__submit[data-show-price="true"]') || []).forEach(b)
	}
	document.addEventListener("DOMContentLoaded", (() => y(document))), document.addEventListener("shopify:section:load", (t => y(t.target))), document.addEventListener("quick-add:loaded", (t => y(t.detail?.modal || t.target || document))), document.addEventListener("modal:open", (t => y(t.target || document))), new MutationObserver((t => {
		for (const e of t)
			for (const t of e.addedNodes || []) t instanceof HTMLElement && (t.matches?.("quick-add-modal, product-modal, modal-dialog, .modal__content, .drawer") || t.querySelector?.('button.product-form__submit[data-price-on-button="true"], button.product-form__submit[data-show-price="true"]')) && y(t)
	})).observe(document.documentElement, {
		childList: !0,
		subtree: !0
	})
})();